import { render, staticRenderFns } from "./DetailDocs.vue?vue&type=template&id=5ab41d4e&scoped=true&"
import script from "./DetailDocs.vue?vue&type=script&lang=js&"
export * from "./DetailDocs.vue?vue&type=script&lang=js&"
import style0 from "./DetailDocs.vue?vue&type=style&index=0&id=5ab41d4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab41d4e",
  null
  
)

export default component.exports